import * as React from 'react';
import * as _ from 'lodash';
import Styled from './Tile.style';
import { Icon, Button, Popup, Typography } from '../index';

interface TileProps {
  title?: string;
  description?: string;
  buttonText?: string;
  icon?: any;
  onButtonClick: Function;
  children?: React.ReactNode;
  isDesktop: boolean;
  theme?: string;
  isPopup?: boolean;
  disabled?: boolean;
  disclaimer?: boolean;
}
export const Tile: React.FC<TileProps> = (props) => {
  const {
    title,
    description,
    buttonText,
    onButtonClick,
    isDesktop,
    theme,
    disabled,
    icon,
  } = props;

  return (
    <Styled.Container>
      <div className="icon-box">{icon}</div>
      <Typography size="3" text={title} style={{ marginBottom: '24px' }} />
      <Typography size="p" text={description} style={{ height: '48px' }} />
      <Styled.CustomButton onClick={onButtonClick}>Explore</Styled.CustomButton>
    </Styled.Container>
  );
};
export default Tile;
